import { useEffect } from "react";

/**
 * Calls `refetch` whenever the browser tab becomes visible again.
 * Use this for low-frequency data (documents, approvals, plan status) instead
 * of a persistent WebSocket subscription — zero cost while the tab is active,
 * and catches remote changes the moment the user switches back.
 */
export function usePageFocus(refetch: () => void) {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refetch();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [refetch]);
}
